// extracted by mini-css-extract-plugin
module.exports = {"text":"big-quote_text__2Aewu","inner":"big-quote_inner__1Scr4","element":"big-quote_element__1Egtx","attribution":"big-quote_attribution__QhMIF"};